import axios from 'axios';
import axiosUrl from './axios.service';
import store from '../store/index';
const API_URL = axiosUrl.getAxiosUrl();

class StatisticsService {
  async subjectCounts(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes,
    isMunicipality,
    kvkNumbers,
    sbiCodes,
  ) {
    return axios
      .post(API_URL + `/Statistics/subjectCounts`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
        isMunicipality: isMunicipality,
        chamberOfCommerces: kvkNumbers != null ? kvkNumbers.map(d => { return d.label}) : [],
        sbiCodes: sbiCodes != null ? sbiCodes.map(d => {return d.label}) : [], 
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullPieChartData', chartData);
      });
  }

  async customerCounts(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes,
    isMunicipality,
    kvkNumbers,
    sbiCodes,
  ) {
    return axios
      .post(API_URL + `/Statistics/customerCounts`, 
      {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
        isMunicipality: isMunicipality,
        chamberOfCommerces: kvkNumbers != null ? kvkNumbers.map(d => { return d.label}) : [],
        sbiCodes: sbiCodes != null ? sbiCodes.map(d => {return d.label}) : [], 
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullHorizontalBarChartData', chartData);
        store.commit('statistics/setIsStatisticLoading', false);
      });
  }

  async customerSubsidy(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes,
    isMunicipality,
    kvkNumbers,
    sbiCodes,
  ) {
    return axios
      .post(API_URL + `/Statistics/customerSubsidy`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
        isMunicipality: isMunicipality,
        chamberOfCommerces: kvkNumbers != null ? kvkNumbers.map(d => { return d.label}) : [],
        sbiCodes: sbiCodes != null ? sbiCodes.map(d => {return d.label}) : [], 
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullBarChartData', chartData);
      });
  }

  async customerSchemes(customerName, year) {
    return axios
      .get(API_URL + `/Statistics/customerSchemes`, {
        params: {
          customerName: customerName,
          year: year,
        },
      })
      .then((response) => {
        var data = response.data;
        store.commit('statistics/setTableRows', data);
      });
  }

  async filterRecords(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes,
    isMunicipality,
    kvkNumbers,
    sbiCodes,
  ) {
    return axios
      .post(API_URL + `/Statistics/filterRecords`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id}) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
        isMunicipality: isMunicipality,
        chamberOfCommerces: kvkNumbers != null ? kvkNumbers.map(d => { return d.label}) : [],
        sbiCodes: sbiCodes != null ? sbiCodes.map(d => {return d.label}) : [], 
      })
      .then((response) => {
        var data = response.data;
        store.commit('statistics/setStatisticsTableRows', data);
      });
  }

  async exportRecords(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes,
    isMunicipality,
    kvkNumbers,
    sbiCodes,
  ) {
    return axios
      .post(API_URL + `/Statistics/exportStatistics`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
        isMunicipality: isMunicipality,
        chamberOfCommerces: kvkNumbers != null ? kvkNumbers.map(d => { return d.label}) : [],
        sbiCodes: sbiCodes != null ? sbiCodes.map(d => {return d.label}) : [], 
      },
      {
        responseType: 'blob'
      })
      .then((res) => {
        const dateTimeTicks = new Date().getTime();
        const fn = 'Statistics' + dateTimeTicks + '.xlsx';
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fn;
        link.click();
        document.body.removeChild(link);
      });
  }
}

export default new StatisticsService();
